import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(search, type, filters = [], hiddenFilter = '',page = 1, sortBy = 'date', sortDesc = false) {

    return Api().post('/client/invoices/search', qs.stringify({
      'search': encodeURIComponent(search),
      'type': type,
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
    }));
  },
}